import { render } from "./ItemsView.vue?vue&type=template&id=be8cbe86&scoped=true"
import script from "./ItemsView.vue?vue&type=script&lang=js"
export * from "./ItemsView.vue?vue&type=script&lang=js"

import "./ItemsView.vue?vue&type=style&index=0&id=be8cbe86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8cbe86"]])

export default __exports__